import React from 'react';
import Head from 'next/head';
import toSafePaginationHref from '../../../../utils/to-safe-pagination-href';

export type PaginationSeoLinksProps = {
  seoPaginationNext: string;
  seoPaginationPrev: string;
};

export const PaginationSeoLinks = ({
  seoPaginationNext,
  seoPaginationPrev,
}: PaginationSeoLinksProps): JSX.Element => {
  const safeSeoPaginationNext = toSafePaginationHref(seoPaginationNext || '');
  const safeSeoPaginationPrev = toSafePaginationHref(seoPaginationPrev || '');

  return (
    <>
      {safeSeoPaginationNext && (
        <Head>
          <link
            title="pagination-seo-next"
            rel="next"
            href={safeSeoPaginationNext}
          />
        </Head>
      )}
      {safeSeoPaginationPrev && (
        <Head>
          <link
            title="pagination-seo-prev"
            rel="prev"
            href={safeSeoPaginationPrev}
          />
        </Head>
      )}
    </>
  );
};
